import axiosInstance, { axiosInstanceCached } from '@/utils/axios';
import { handleApiError } from '@/utils/helpers';

// @ Create Event Queue ✅
// @ payload: event_id
// @ payload: clubhouse_id
export const queueCreate = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/event_queue_create`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ List Queues for an Event ✅
// @ payload: event_id
// @ payload: clubhouse_id
export const queueList = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/event_queue_list`, payload);

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Get Single Event Queue ✅
export const queueGet = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/event_get`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Delete Queue for an Event ✅
// @ payload: id or
// @ payload: code
// @ payload: event_id or
// @ payload: clubhouse_id
export const queueDelete = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/event_queue_delete`, payload);

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Empty Queue for an Event ✅
// @ payload: id or
// @ payload: code
// @ payload: event_id or
// @ payload: clubhouse_id
export const queueEmpty = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/event_queue_empty`, payload);

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Unbind Queue from Sim ✅
// @ payload: queue_code
export const queueUnbind = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/event_queue_unbind_sim`, payload);

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Add User To Queue ✅
// @ payload: id or
// @ payload: code
// @ payload: event_id or
// @ payload: clubhouse_id
// @ payload: user_id
// @ payload: user_state
export const queueAddUser = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/event_queue_add_user`, payload);

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Remove User From Queue ✅
// @ payload: id or
// @ payload: code
// @ payload: event_id or
// @ payload: clubhouse_id
// @ payload: user_id
export const queueRemoveUser = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/event_queue_remove_user`, payload);

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Reorder User in Queue ✅
// @ payload: id or
// @ payload: code
// @ payload: event_id or
// @ payload: clubhouse_id
// @ payload: user_id
// @ payload: new_index
export const queueReorderUser = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/event_queue_reorder_user`, payload);

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Reorder User in Queue ✅
// @ payload: from_code
// @ payload: to_code
// @ payload: user_id
// @ payload: new_index - NEED THIS
export const queueTransferUser = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/event_queue_transfer_user`, payload);

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Set User State in Queue ✅
// @ payload: id or
// @ payload: code
// @ payload: event_id or
// @ payload: clubhouse_id
// @ payload: user_id
// @ payload: user_state (active/disabled)
export const queueSetUserState = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/event_queue_set_user_state`, payload);

    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
